export default __webpack_public_path__ + "static/media/658.a8b8671d.gif";